import { ReactNode } from 'react'
import { useDelayedLoading } from '../../hooks/useDelayedLoading'

interface Props {
    isFetching: boolean
    children: ReactNode
}

export default function DelayedLoadingWrapper({ isFetching, children }: Props) {
    const showDelayedSpinner = useDelayedLoading(isFetching, 1000)

    return (
        <div style={{ height: '100%', position: 'relative' }}>
            <div
                style={{
                    height: '100%',
                    opacity: showDelayedSpinner ? 0.4 : 1,
                    pointerEvents: showDelayedSpinner ? 'none' : 'auto',
                    transition: 'opacity 0.3s ease-in-out'
                }}
            >
                {children}
            </div>

            {showDelayedSpinner && (
                <div style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none'
                }}>
                    <div className="spinner-subtle" />
                </div>
            )}
        </div>
    )
}
